import React from 'react';

type Props = {color?: string};

export const TransactionsTabSvg: React.FC<Props> = ({color = '#FF8A71'}) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={50} height={24} fill='none'>
    <rect x='17' y='5' width='16' height='14' rx='2' stroke={color} strokeWidth='1.5' fill='none'/>
    <path stroke={color} strokeWidth='1.5' strokeLinecap='round' d='M20 9.5h10M20 12h7M20 14.5h5'/>
  </svg>
);
